// extracted by mini-css-extract-plugin
module.exports = {"inputShift":"_2uNqG","focused":"_1EiBa","active":"_3NMN-","phoneNumberPrefix":"_1O1ok","withPrefix":"_3WHsb","withPadding":"_3W8ym","error":"_2Icpb","errorBorder":"_13EvM"};